import { Entity } from '../entity.js';
import { blinkToward, isInAbilityCircle, isWithinAbilityRange } from '../combat/abilityArea.js';

export function createKatarina(id = 'katarina-1', team = 'blue', x = 300, y = 1300) {
  return new Entity({
    id,
    type: 'champion',
    team,
    x,
    y,
    maxHp: 550,
    maxMp: 0,
    ad: 60,
    ap: 0,
    armor: 28,
    mr: 32,
    ms: 335,
    attackRange: 125,
    attackSpeed: 0.658,
    name: 'Katarina',
    radius: 20
  });
}

const Q_BOUNCE_RADIUS = 375;
const Q_BOUNCE_MAX = 2;

export function castKatarinaQ(caster, selectedTarget, entities = []) {
  if (!caster || caster.isDead || !selectedTarget || selectedTarget.isDead) return false;
  if (selectedTarget.team === caster.team) return false;
  if (!isWithinAbilityRange(caster, selectedTarget, 625, caster)) return false;
  const damage = 75 + (caster.ap || 0) * 0.55;
  selectedTarget.takeDamage(damage, caster, 'magic');
  let bounced = 0;
  for (const e of entities) {
    if (!e || e === selectedTarget || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityCircle(e, selectedTarget.x, selectedTarget.y, Q_BOUNCE_RADIUS, caster)) continue;
    e.takeDamage(damage * 0.85, caster, 'magic');
    bounced += 1;
    if (bounced >= Q_BOUNCE_MAX) break;
  }
  return true;
}

export function castKatarinaW(caster) {
  if (!caster || caster.isDead) return false;
  caster.buffs = caster.buffs || [];
  caster.buffs.push({ id: 'katarina_w', msPercent: 0.15, duration: 1.25 });
  return true;
}

export function castKatarinaE(caster, tx, ty) {
  if (!caster || caster.isDead) return false;
  blinkToward(caster, tx, ty, 725);
  return true;
}

export function castKatarinaR(caster, entities) {
  if (!caster || caster.isDead) return false;
  for (const e of entities || []) {
    if (!e || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityCircle(e, caster.x, caster.y, 550, caster)) continue;
    e.takeDamage(30 + (caster.ap || 0) * 0.19, caster, 'magic');
  }
  return true;
}
